// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__2zwEN","content":"Footer_content__107KB","text":"Footer_text__6iDdH"};